import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import LzCrudModel from '../../../models/crud';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Alert from '@material-ui/lab/Alert';
import RefreshIcon from '@material-ui/icons/Refresh';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import TuneIcon from '@material-ui/icons/Tune';
import Tooltip from '@material-ui/core/Tooltip';
import LzToolbar from '../toolbar';
import LzFiltersDialog from '../filters-dialog';

class LzCrudListingComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showFilters: false,
        };

        this.importFileRef = React.createRef();
    }

    handleActionIconClick(key, record) {
        this.props.onActionIconClick(key, record);
    }

    handleGroupActionIconClick(key, confirmation) {
        const { onGroupActionIconClick } = this.props;

        onGroupActionIconClick(key, confirmation);
    }

    showImportFileDialog() {
        this.importFileRef.current.click();
    }

    clearImportFileInput() {
        this.importFileRef.current.value = '';
    }

    onImportFileChange(event) {
        event.stopPropagation();
        event.preventDefault();
        const file = event.target.files[0];
        // console.log('File to Import:', file);
        this.props.onImport(file);
        this.clearImportFileInput();
    }

    onShowFilters() {
        const { showFilters } = this.state;
        const { onShowFilters } = this.props;

        this.setState({ showFilters: !showFilters });

        if (onShowFilters) {
            onShowFilters();
        }
    }

    getToolbarItems(crudConfig, totalChecked, showDeleted, filters) {
        const out = [];

        if (totalChecked > 0) {
            for (const key in crudConfig.listingGroupActionIcons) {
                const ai = crudConfig.listingGroupActionIcons[key];
                out.push({ label: ai.title, icon: ai.icon, color: ai.color, onClick: () => this.handleGroupActionIconClick(key, ai.confirmation) });
            }
        } else {
            const { onRefresh, onExport, onResetFilters, onShowDeletedChange } = this.props;

            if (onRefresh) {
                out.push({ label: 'Refresh', icon: <RefreshIcon />, color: 'success', onClick: () => onRefresh() });
            }
            if (crudConfig.showExport) {
                out.push({ label: 'Export CSV', icon: <GetAppIcon />, color: 'info', onClick: () => onExport() });
            }
            if (crudConfig.showImport) {
                out.push({ label: 'Import CSV', icon: <PublishIcon />, color: 'info', onClick: () => this.showImportFileDialog() });
            }
            if (crudConfig.showAdd) {
                out.push({ label: 'Create ' + crudConfig.label, icon: <AddIcon />, color: 'info', route: crudConfig.baseRoute + '/add' });
            }
            if (filters && onResetFilters) {
                out.push({ label: 'Show Filters', icon: <TuneIcon />, color: 'warning', onClick: () => this.onShowFilters() });
            }
            for (const key in crudConfig.listingGroupActionIcons) {
                const ai = crudConfig.listingGroupActionIcons[key];
                if (ai.checksNotRequiredToShow) {
                    out.push({ label: ai.title, icon: ai.icon, color: ai.color, onClick: () => this.handleGroupActionIconClick(key, ai.confirmation) });
                }
            }
            if (crudConfig.showDeletedList) {
                if (showDeleted) {
                    out.push({ label: 'Hide Deleted Records ', icon: <DeleteForeverIcon />, color: 'warning', onClick: () => onShowDeletedChange(false) });
                } else {
                    out.push({ label: 'Show Deleted Records', icon: <DeleteIcon />, color: 'warning', onClick: () => onShowDeletedChange(true) });
                }
            }
        }

        return out;
    }

    getToolbarOtherStack(totalChecked) {
        if (totalChecked > 0) {
            return (
                <Typography color="inherit" variant="subtitle1">
                    &nbsp; {totalChecked} selected
                    <Tooltip title="Clear Selections">
                        <IconButton onClick={() => this.props.onCheckedIdsChange([])}>
                            <ClearAllIcon />
                        </IconButton>
                    </Tooltip>
                </Typography>
            );
        }

        return '';
    }

    handleCheckAllClick(checked) {
        const { onCheckedIdsChange } = this.props;

        if (checked) {
            onCheckedIdsChange(this.props.records.map(r => r.id));
        } else {
            onCheckedIdsChange([]);
        }
    }

    handleCheckClick(checked, id) {
        const { onCheckedIdsChange } = this.props;
        const checkedIds = this.props.checkedIds.slice();   // get a copy of the checkedIds
        const dex = checkedIds.indexOf(id);                 // get the selected index of the id in checkedIds if any

        // If it was supposed to be checked but is not
        if (checked && dex < 0) {
            checkedIds.push(id);
            onCheckedIdsChange(checkedIds);
            return;
        }

        // If it was not supposed to be checked but it is
        if (!checked && dex >= 0) {
            checkedIds.splice(dex, 1);
            onCheckedIdsChange(checkedIds);
        }
    }

    applyFilters() {
        this.props.onRefresh();
        this.setState({ showFilters: false });
    }

    render() {
        const { showFilters } = this.state;
        const {
            records, config, currentPage, totalRecords, recordsPerPage, filters, contentAboveListing, sortKey,
            sortDir, onSortChange, checkedIds, onResetFilters, onPageChange, onRecordsPerPageChange, showDeleted,
            elevation, extraParams
        } = this.props;

        const totalVisibleRows = records.length;
        const totalChecked = checkedIds.length;

        if (!records) {
            return <CircularProgress />;
        }

        const crudConfig = new LzCrudModel(config);
        if ('' === crudConfig.ident) {
            return <Alert variant="filled" severity="error">Crud config is missing!</Alert>;
        }

        const lstCols = crudConfig.listingColumns;
        const lstColsKeys = Object.keys(lstCols);

        const lstActIcons = crudConfig.listingActionIcons;
        const lstActIconsKeys = Object.keys(lstActIcons);

        // console.log('CRUD-CONFIG', crudConfig);

        return (
            <React.Fragment>
                <Paper elevation={typeof elevation === 'undefined' ? 3 : +elevation} style={{ width: '100%' }}>

                    <LzToolbar icons
                        highlighted={totalChecked > 0}
                        items={this.getToolbarItems(crudConfig, totalChecked, showDeleted, filters)}
                        otherStack={this.getToolbarOtherStack(totalChecked)}
                    />

                    {crudConfig.showImport &&
                        <input ref={this.importFileRef} type="file" style={{ display: "none" }} onChange={(event) => this.onImportFileChange(event)} accept=".csv" />
                    }

                    <LzFiltersDialog show={filters && onResetFilters && showFilters}
                        onClose={() => this.setState({ showFilters: false })}
                        onReset={() => onResetFilters()}
                        onApply={() => this.applyFilters()}
                    >{filters}</LzFiltersDialog>

                    {contentAboveListing}

                    {records.length < 1 ?
                        <Alert color="warning">No records found!</Alert>
                        :
                        <React.Fragment>
                            <TableContainer>
                                <Table stickyHeader className="lz-crud-listing-table">
                                    <TableHead>
                                        <TableRow>
                                            {crudConfig.hasGroupActions &&
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        indeterminate={totalChecked > 0 && totalChecked < totalVisibleRows}
                                                        checked={totalVisibleRows > 0 && totalChecked === totalVisibleRows}
                                                        onChange={(ev) => this.handleCheckAllClick(ev.target.checked)}
                                                    />
                                                </TableCell>
                                            }

                                            {lstColsKeys.map((colKey, colDex) =>
                                                <TableCell
                                                    key={'lc-' + colDex}
                                                    align={lstCols[colKey].alignment}
                                                    sortDirection={sortKey === colKey ? sortDir : false}
                                                    className="lz-list-head"
                                                >
                                                    {lstCols[colKey].sortable ?
                                                        <TableSortLabel
                                                            active={sortKey === colKey}
                                                            direction={sortDir}
                                                            onClick={() => onSortChange(colKey, sortKey === colKey ? ('desc' === sortDir ? 'asc' : 'desc') : 'asc')}
                                                        >
                                                            {lstCols[colKey].icon && <React.Fragment>{lstCols[colKey].icon}</React.Fragment>}
                                                            {lstCols[colKey].label}
                                                        </TableSortLabel>
                                                        :
                                                        <React.Fragment>
                                                            {lstCols[colKey].icon && <React.Fragment>{lstCols[colKey].icon}</React.Fragment>}
                                                            {lstCols[colKey].label}
                                                        </React.Fragment>
                                                    }
                                                </TableCell>
                                            )}

                                            {lstActIconsKeys.length > 0 &&
                                                <TableCell align="center" style={{ width: 1 }}>Actions</TableCell>
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {records.map((record, trDex) => {

                                            const isChecked = checkedIds.indexOf(record.id) >= 0;

                                            return (
                                                <TableRow hover selected={isChecked} key={'trKey-' + trDex}>
                                                    {crudConfig.hasGroupActions &&
                                                        <TableCell padding="checkbox">
                                                            <Checkbox
                                                                checked={isChecked}
                                                                onChange={(ev) => this.handleCheckClick(ev.target.checked, record.id)}
                                                            />
                                                        </TableCell>
                                                    }

                                                    {lstColsKeys.map((colKey, colDex) =>
                                                        <TableCell
                                                            key={'tdKey-' + trDex + '-' + colDex}
                                                            align={lstCols[colKey].alignment}
                                                            className={'' + (lstCols[colKey].isMedia ? ' lz-crud-media-td' : '')}
                                                        >
                                                            {lstCols[colKey].displayFunction(record[colKey], record)}
                                                        </TableCell>
                                                    )}

                                                    {lstActIconsKeys.length > 0 &&
                                                        <TableCell padding="none" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>

                                                            {lstActIconsKeys.map((actionIconKey, actIconDex) => {
                                                                const actIcon = lstActIcons[actionIconKey];

                                                                if (
                                                                    (!!record.deleted_at && actIcon.hideOnDeleted) ||
                                                                    (!record.deleted_at && actIcon.showOnDeletedOnly)
                                                                ) {
                                                                    return '';
                                                                }

                                                                if (actIcon.showOnlyEvaluator && !actIcon.showOnlyEvaluator(record, extraParams)) {
                                                                    return '';
                                                                }

                                                                return (
                                                                    <Tooltip key={'tdAKey-' + trDex + '-' + actIconDex} title={actIcon.getTitle(record)}>
                                                                        {'' === actIcon.route ?
                                                                            <IconButton
                                                                                className={'lz-icon-button-' + actIcon.getColor(record)}
                                                                                onClick={() => this.handleActionIconClick(actionIconKey, record)}
                                                                            >
                                                                                {actIcon.getIcon(record)}
                                                                            </IconButton>
                                                                            :
                                                                            <Link
                                                                                to={actIcon.route.replace('{baseRoute}', config.baseRoute).replace('{recordId}', record.id)}
                                                                                target={actIcon.routeTarget}
                                                                            >
                                                                                <IconButton className={'lz-icon-button-' + actIcon.getColor(record)} >
                                                                                    {actIcon.getIcon(record)}
                                                                                </IconButton>
                                                                            </Link>
                                                                        }
                                                                    </Tooltip>
                                                                );
                                                            })}

                                                        </TableCell>
                                                    }

                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <TablePagination
                                component="div"
                                page={currentPage}
                                count={totalRecords}
                                onPageChange={(evt, page) => onPageChange(+page)}
                                rowsPerPage={recordsPerPage}
                                onRowsPerPageChange={(evt) => onRecordsPerPageChange(evt.target.value)}
                            />
                        </React.Fragment>
                    }

                </Paper>
            </React.Fragment>
        );
    }

}

export default withRouter(LzCrudListingComponent);
